const userConstants = {
  ADD_TO_BOOKMARKS_REQUEST: 'ADD_TO_BOOKMARKS_REQUEST',
  ADD_TO_BOOKMARKS_SUCCESS: 'ADD_TO_BOOKMARKS_SUCCESS',
  ADD_TO_BOOKMARKS_FAILURE: 'ADD_TO_BOOKMARKS_FAILURE',
  REMOVE_BOOKMARKS:         'REMOVE_BOOKMARKS',

  GET_APPEAL_TOKEN_FAILURE: 'GET_APPEAL_TOKEN_FAILURE',
  GET_APPEAL_TOKEN_REQUEST: 'GET_APPEAL_TOKEN_REQUEST',
  GET_APPEAL_TOKEN_SUCCESS: 'GET_APPEAL_TOKEN_SUCCESS',
  SEND_APPEAL_FAILURE:      'SEND_APPEAL_FAILURE',
  SEND_APPEAL_REQUEST:      'SEND_APPEAL_REQUEST',
  SEND_APPEAL_SUCCESS:      'SEND_APPEAL_SUCCESS',

  CHANGE_PASSWORD_FAILURE:             'CHANGE_PASSWORD_FAILURE',
  CHANGE_PASSWORD_REQUEST:             'CHANGE_PASSWORD_REQUEST',
  CHANGE_PASSWORD_SUCCESS:             'CHANGE_PASSWORD_SUCCESS',
  GET_AUTH_TOKEN_FAILURE:              'GET_AUTH_TOKEN_FAILURE',
  GET_AUTH_TOKEN_REQUEST:              'GET_AUTH_TOKEN_REQUEST',
  GET_AUTH_TOKEN_SUCCESS:              'GET_AUTH_TOKEN_SUCCESS',
  GET_REACTIVATION_LINK_FAILURE:       'GET_REACTIVATION_LINK_FAILURE',
  GET_REACTIVATION_LINK_REQUEST:       'GET_REACTIVATION_LINK_REQUEST',
  GET_REACTIVATION_LINK_SUCCESS:       'GET_REACTIVATION_LINK_SUCCESS',
  GET_USER_INFO_FAILURE:               'GET_USER_INFO_FAILURE',
  GET_USER_INFO_REQUEST:               'GET_USER_INFO_REQUEST',
  GET_USER_INFO_SUCCESS:               'GET_USER_INFO_SUCCESS',
  PROFILE_GET_INITIAL_STATE_FAILURE:   'PROFILE_GET_INITIAL_STATE_FAILURE',
  PROFILE_GET_INITIAL_STATE_REQUEST:   'PROFILE_GET_INITIAL_STATE_REQUEST',
  PROFILE_GET_INITIAL_STATE_SUCCESS:   'PROFILE_GET_INITIAL_STATE_SUCCESS',
  PROFILE_SUBMIT_ACCOUNT_DATA_FAILURE: 'PROFILE_SUBMIT_ACCOUNT_DATA_FAILURE',
  PROFILE_SUBMIT_ACCOUNT_DATA_REQUEST: 'PROFILE_SUBMIT_ACCOUNT_DATA_REQUEST',
  PROFILE_SUBMIT_ACCOUNT_DATA_SUCCESS: 'PROFILE_SUBMIT_ACCOUNT_DATA_SUCCESS',
  PROFILE_SUBMIT_USER_DATA_FAILURE:    'PROFILE_SUBMIT_USER_DATA_FAILURE',
  PROFILE_SUBMIT_USER_DATA_REQUEST:    'PROFILE_SUBMIT_USER_DATA_REQUEST',
  PROFILE_SUBMIT_USER_DATA_SUCCESS:    'PROFILE_SUBMIT_USER_DATA_SUCCESS',
  USER_CHANGE_LOCATION_FAILURE:        'USER_CHANGE_LOCATION_FAILURE',
  USER_CHANGE_LOCATION_REQUEST:        'USER_CHANGE_LOCATION_REQUEST',
  USER_CHANGE_LOCATION_SUCCESS:        'USER_CHANGE_LOCATION_SUCCESS',
  USER_DELETE_FAILURE:                 'USER_DELETE_FAILURE',
  USER_DELETE_REQUEST:                 'USER_DELETE_REQUEST',
  USER_DELETE_SUCCESS:                 'USER_DELETE_SUCCESS',
  USER_GET_LOCATION_FAILURE:           'USER_GET_LOCATION_FAILURE',
  USER_GET_LOCATION_REQUEST:           'USER_GET_LOCATION_REQUEST',
  USER_GET_LOCATION_SUCCESS:           'USER_GET_LOCATION_SUCCESS',
  USER_LOGIN_FAILURE:                  'USER_LOGIN_FAILURE',
  USER_LOGIN_REQUEST:                  'USER_LOGIN_REQUEST',
  USER_LOGIN_SUCCESS:                  'USER_LOGIN_SUCCESS',
  USER_LOGOUT_REQUEST:                 'USER_LOGOUT_REQUEST',
  USER_LOGOUT_SUCCESS:                 'USER_LOGOUT_SUCCESS',
  USER_REGISTER_FAILURE:               'USER_REGISTER_FAILURE',
  USER_REGISTER_REQUEST:               'USER_REGISTER_REQUEST',
  USER_REGISTER_SUCCESS:               'USER_REGISTER_SUCCESS',

  STORAGE: 'USER_STORAGE',
};

export default userConstants;